import InspectionDetails from './InspectionDetails';

export default InspectionDetails;
